import React, { Component } from 'react';
import PropTypes from 'prop-types';
import aboutIcon1 from '../../assets/aboutIcon1.png';
import aboutIcon2 from '../../assets/aboutIcon2.png';
import aboutIcon3 from '../../assets/aboutIcon3.png';

import {
  StyledImage,
  TutItem,
  TutText,
  TutLink,
  TutContainer,
  Title,
  TutNavLink,
  TutPageWrap,
} from './TutorialDescription.styles';

/**
 * A component for TutorialDescriptions
 *
 * @param {} src - Description of src
 * @param {} height - Description of height
 * @param {} width - Description of width
 */
export default class TutorialDescription extends Component {
  static propTypes = {
    goToRandomQuiz: PropTypes.func.isRequired,
  };

  render() {
    const { goToRandomQuiz } = this.props;
    return (
      <TutContainer>
        <TutPageWrap>
          <Title>
            How does QuizHive work?
          </Title>
          <TutItem>
            <StyledImage
              src={ aboutIcon1 }
              height={ 150 }
              width={ 150 }
              alt="Answer Questions!"
            />
            <TutText>
              Answer questions with your fiery wit and intelligence.
            </TutText>
            <TutLink onClick={ goToRandomQuiz }>Go To a Random Question</TutLink>
          </TutItem>
          <TutItem>
            <StyledImage
              src={ aboutIcon2 }
              height={ 150 }
              width={ 150 }
              alt="Climb the Leaderboard!"
            />
            <TutText>
              Score points and climb the leaderboard of success.
            </TutText>
            <TutNavLink to="/leaderboard">View Leaderboard</TutNavLink>
          </TutItem>
          <TutItem>
            <StyledImage
              src={ aboutIcon3 }
              height={ 150 }
              width={ 150 }
              alt="Challenge Your Friends!"
            />
            <TutText>
              Share to compete against friends. Try your best to remain friends.
            </TutText>
            <TutNavLink to="/share">Share QuizHive</TutNavLink>
          </TutItem>
        </TutPageWrap>
      </TutContainer>
    );
  }
}
